import { SimilaritiesActionsEnum } from '../enums/SimilaritiesActionsEnum';
import { ISimilaritiesState } from '../interfaces/ISimilaritiesState';
import { SimilaritiesAction } from '../types/SimilaritiesAction';

const initial: ISimilaritiesState = {
  page: 0,
  data: [],
  pageCount: 0,
  totalCount: 0,
  order: '',
  notProcessedCount: 0,
  filter: {},
  similaritiesById: [],
  orderById: '',
  filterById: {},
};

export function similaritiesReducer(state = initial, action: SimilaritiesAction) {
  switch (action.type) {
    case SimilaritiesActionsEnum.SIMILARITIES_SET_DATA: {
      const { data, page, pageCount, totalCount, notProcessedCount } = action.payload;
      const newState: ISimilaritiesState = {
        ...state,
        data,
        page,
        pageCount,
        totalCount,
        notProcessedCount,
      };

      return newState;
    }
    case SimilaritiesActionsEnum.SIMILARITIES_SET_ORDER: {
      const newState: ISimilaritiesState = {
        ...state,
        order: action.payload.order,
      };

      return newState;
    }
    case SimilaritiesActionsEnum.SIMILARITIES_SET_SEARCH_STRING: {
      const newState: ISimilaritiesState = {
        ...state,
        searchString: action.payload.searchString,
      };

      return newState;
    }
    case SimilaritiesActionsEnum.SIMILARITIES_SET_FILTER: {
      const newState: ISimilaritiesState = {
        ...state,
        filter: action.payload.filter,
      };

      return newState;
    }
    case SimilaritiesActionsEnum.SIMILARITIES_SET_DATA_BY_ID: {
      const newState: ISimilaritiesState = {
        ...state,
        similaritiesById: action.payload.similaritiesById,
      };

      return newState;
    }
    case SimilaritiesActionsEnum.SIMILARITIES_SET_ORDER_BY_ID: {
      const newState: ISimilaritiesState = {
        ...state,
        orderById: action.payload.order,
      };

      return newState;
    }
    case SimilaritiesActionsEnum.SIMILARITIES_SET_FILTER_BY_ID: {
      const newState: ISimilaritiesState = {
        ...state,
        filterById: action.payload.filter,
      };

      return newState;
    }
    case SimilaritiesActionsEnum.SIMILARITIES_SET_PERSON_ID: {
      const newState: ISimilaritiesState = {
        ...state,
        personId: action.payload.id,
      };

      return newState;
    }
    case SimilaritiesActionsEnum.SIMILARITIES_SET_FETCH_SETTING_BY_CODE: {
      const newState: ISimilaritiesState = {
        ...state,
        settings: action.payload.settings,
      };

      return newState;
    }
    default:
      return state;
  }
}
